import * as React from "react";
import { Row, Col } from "antd";
import styled from "styled-components";
import {
  numericDate,
  displayStringForOrderStatus
} from "../../../lib/formatters";
import { OrderStatus } from "../../../lib/model/OrderStatus";

const DataLabelBold = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.29;
  color: #1d1d1b;
`;

const DataLabel = styled.span`
  font-size: 14px;
  font-weight: 300;
  line-height: 1.29;
  color: #1d1d1b;
`;

const StatusTitleLabel = styled.span`
  font-size: 11px;
  font-weight: 400;
  line-height: 1.27;
  text-align: left;
  color: #1d1d1b;
`;

const StatusPill = styled.span`
  font-size: 11px;
  font-weight: 300;
  line-height: 1.27;
  color: #061a32;
  padding: 2px 17px;
  border-radius: 10px;
  background-color: #dedede;
`;

type Props = {
  id: string;
  internalReference?: string;
  date: Date;
  status: OrderStatus;
  bookingMember?: string;
};

export const OrderDetailsHeader: React.FC<Props> = props => {
  const { id, internalReference, date, bookingMember } = props;
  return (
    <Row type="flex" justify="space-between" align="bottom">
      <Col md={24} xs={24}>
        <DataLabelBold>Auftrag: </DataLabelBold>
        <DataLabel>{id}</DataLabel>
        <br />
        {!!bookingMember && (
          <>
            <DataLabelBold>Gebucht von: </DataLabelBold>
            <DataLabel>{bookingMember}</DataLabel>
            <br />
          </>
        )}
        <DataLabelBold>Referenz: </DataLabelBold>
        <DataLabel>{internalReference}</DataLabel>
        <br />
        <DataLabelBold>Datum: </DataLabelBold>
        <DataLabel>{numericDate(date)}</DataLabel>
        <br />
        <div style={{ width: "100%", textAlign: "right" }}>
          <StatusTitleLabel>Status</StatusTitleLabel>{" "}
          <StatusPill>{displayStringForOrderStatus(props.status)}</StatusPill>
        </div>
      </Col>
    </Row>
  );
};
